<template><div class="view">

	<main>

		<blocks v-if="!editing_blocks" :blocks="blocks" :metadata="blocks_metadata" />		
		<block-editor v-if="editing_blocks" :blocks="blocks" :route_name="$route.name" :page_slug="blocks_pagekey" @updated="blocksUpdated()" />

		<error-404 v-if="!blocks && !is_fetching_content" />	
		
	</main>


</div></template>
<script>
import helpers from '.././helpers.js'
import mixins from '.././mixins.js'
import store from '.././store/store.js'

import Blocks from '.././components/Blocks'
import BlockEditor from '.././views/admin/AdminBlockEditor'

export default {
	
	mixins: [ mixins.generic ],
	
	components: {
		Blocks, BlockEditor, 
	},

	data(){ return {
			

	}},

	computed: {

		gender(){ return this.$route.params.gender },
		gender2(){ 
			if( this.gender == 'women' ) return 'female'
			if( this.gender == 'men' ) return 'male'
		},

		book(){ return this.$route.params.book },

		blocks_pagekey(){
			var page_key = 'models-' + this.book
			if( this.gender ) var page_key = 'models-' + this.gender + '-' + this.book		
			return page_key
		},

		blocks(){ return this.$store.state.loaded_blocks },

		blocks_metadata(){
			return {
				context: 'model-list',
				active_book: this.book,
			}
		},

		pageTitle(){

			var title = ''

			if( this.gender ) title += helpers.capitalize(this.gender) + ' / '
			
			title += helpers.unslugify(this.book)

			return title

		},

	},

	methods: {

		load_blocks(){
			
			var _this = this

			var page_key = this.blocks_pagekey
			if( !page_key ) return

			this.$store.commit('set_loaded_blocks', undefined )

			this.fetch( 'get_profileboard_entries', { type:'model', gender:this.gender2, board:this.book }, 
			{ onSuccess: function(output){
				
				if( !output.data || !output.data.result || !output.data.result.blocks ) {
					console.log('valid request, but missing data')												
					return
				}

				_this.$store.commit('set_loaded_blocks', output.data.result.blocks )
				window.prerenderReady = true

				if( window.scoop_onLoadScrollTo ) {
					setTimeout(()=>{
						window.scrollTo(window.scoop_onLoadScrollTo.x, window.scoop_onLoadScrollTo.y)
						window.scoop_onLoadScrollTo = undefined
					}, 0)					
				}

			}, onError: function(output){

				console.log('NAH - fetched but with error',output)		

			}})
				
		},
		
		load_blocks_old(){
			
			var _this = this

			var page_key = this.blocks_pagekey
			if( !page_key ) return

			this.$store.commit('set_loaded_blocks', undefined )

			this.fetch( 'get_blocks_by_pagekey', { page_key:page_key, }, 
			{ onSuccess: function(output){
				
				if( !output.data || !output.data.blocks ) {
					console.log('valid request, but missing data')												
					return
				}

				_this.$store.commit('set_loaded_blocks', output.data.blocks )

			}, onError: function(output){

				console.log('NAH - fetched but with error',output)		

			}})
				
		},
	

		blocksUpdated(){
			this.load_blocks()
		},


	},

	watch: {
		'$route' (to, from) {
			this.load_blocks()
			this.setDocumentTitle( this.pageTitle )
		}
	},
	
	mounted(){
		
		this.setDocumentTitle( this.pageTitle )
		this.load_blocks()
	},

}
</script>



// WEBPACK FOOTER //
// src/views/ModelList.vue